import React from 'react';


import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
const OTP = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const email = location.state?.email;

    const handleClick = () => {
        navigate("/checkList")
    };
    const maskEmail = (email) => {
        if (!email) return '';
        const [name, domain] = email.split('@');
        const maskedName = name[0] + name.slice(1).replace(/./g, '*');
        return `${maskedName}@${domain}`;
    };

    return (
        <div>
            <div className="bg-image d-flex justify-content-center align-items-center bannerOtp">
                <div className="popupWht">
                    <div className="row">
                        <div className="col-sm-12">
                            <h3 className="marB10">Let's confirm it's you</h3>
                            <p className="marB30">
                                Enter the 6-digit OTP sent on {maskEmail(email)}
                            </p>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-7">
                            <div className="form-group otpForm">
                                <input
                                    type="text"
                                    name="otp"
                                    className="form-control"
                                    placeholder="OTP"
                                    value={props.otp}
                                    onChange={props.handleChange}
                                    maxLength="6"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            props.handleSubmit(e);
                                        }
                                    }}
                                />
                                {props.error && (
                                    <p
                                        className={`additional-styles ${props.errorSucess ? "text-success" : "text-danger"}`}
                                    >
                                        {props.error}
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-5">
                            <a onClick={props.handleSubmitResendOtp} className="resendOtp">Resend OTP</a>
                        </div>
                    </div>

                    {/* Buttons */}
                    <button onClick={handleClick} className="btn btn-sm btn-secondary secondaryBtn">BACK</button>&nbsp;&nbsp;
                    <button onClick={props.handleSubmit} className="btn btn-sm btn-primary primaryBtn"
                        type="submit"
                        disabled={props.loading}
                    >VERIFY</button>
                </div>
            </div>


        </div>
    );
};

export default OTP;
